import cx from 'classnames';
import React from 'react';

import styles from './styles.css';
import Box, { BoxProps } from '../Box';

export interface TextareaProps extends BoxProps, React.HTMLProps<HTMLTextAreaElement> {
  hasError?: boolean;
  hasWarning?: boolean;
}

const Textarea: React.FC<TextareaProps> = ({ className, hasError, hasWarning, ...rest }) => {
  const classNames = cx(styles['textarea'], className, {
    [styles['has-error']]: hasError,
    [styles['has-warning']]: hasWarning,
  });

  return <Box element="textarea" className={classNames} {...rest} />;
};

export default Textarea;
